import { render, staticRenderFns } from "./CzChip.vue?vue&type=template&id=66f9c716&scoped=true&"
import script from "./CzChip.vue?vue&type=script&lang=ts&"
export * from "./CzChip.vue?vue&type=script&lang=ts&"
import style0 from "./CzChip.vue?vue&type=style&index=0&id=66f9c716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f9c716",
  null
  
)

export default component.exports